<template>
  <div class="order text-neutral-500">
    <div class="bg-white mb-40">
      <div class="flex gap-3 justify-between p-6 shadow-border-b">
        <div class="flex gap-3">
          <span class="flex justify-center items-center px-2 py-1 text-xs rounded-md " :style="'backgroundColor: ' + insufficientPaymentDetail.status_color + '; color: white;'">{{
            insufficientPaymentDetail.status_display
          }}</span>
          <div>
            <span class="text-neutral-500 text-xs block mb-1">{{ insufficientPaymentDetail.created_time_display }} / {{ insufficientPaymentDetail.order_id }}</span>
            <p class="text-neutral-500 text-xs flex items-center gap-2 mdmax:flex-col mdmax:gap-1 mdmax:items-start">
              <span><strong>AWB Linknau</strong>: {{ insufficientPaymentDetail.order_delivery?.awb }}</span>
              <template v-if="insufficientPaymentDetail.order_delivery?.external_awb">
                <span class="mdmax:hidden">|</span> <span><strong>AWB Mitra</strong>: {{ insufficientPaymentDetail.order_delivery?.external_awb }}</span>
              </template>
            </p>
          </div>
        </div>
        <div class="" v-if="isConfirmButtonVisible">
          <Button buttonText="Konfirmasi" @action="toggleConfirmModal()" />
        </div>
      </div>
      <div class="flex mdmax:flex-col">
        <div class="flex-1">
          <div class="p-6 shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Berat dan Jenis Paket</p>
            <div
              class="flex justify-start gap-6 mb-4 border rounded-md px-3 py-2 bg-neutral-200 last:mb-0"
              v-for="(packageItem, index) in insufficientPaymentDetail?.order_delivery?.packages"
              :key="'package-' + index"
            >
              <div class="flex-1">
                <p class="text-sm font-medium mb-1 text-neutral-700">Berat Barang</p>
                <p>{{ packageItem.weight }}kg</p>
              </div>
              <div class="flex-1">
                <p class="text-sm font-medium mb-1 text-neutral-700">Jenis Paket</p>
                <p>{{ packageItem.category }}</p>
              </div>
              <div class="flex-1">
                <p class="text-sm font-medium mb-1 text-neutral-700">Kurang Bayar</p>
                <p>{{ insufficientPaymentDetail?.order_delivery?.additional_package_charge?.add_cost | currencyFormat }}</p>
              </div>
            </div>
          </div>
          <div class="p-6 shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Layanan</p>
            <div class="flex items-center">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Nama Layanan</p>
                <p>{{ insufficientPaymentDetail.order_delivery?.service_package_name || '-' }}</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Tipe Layanan</p>
                <p>{{ getServiceType(insufficientPaymentDetail.order_delivery?.service_type) || '-' }}</p>
              </div>
            </div>
          </div>
          <div class="p-6">
            <p class="text-xl font-bold mb-6 text-neutral-700">Info Pengiriman</p>
            <div class="flex justify-start gap-6 mb-6">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Nama Pengirim</p>
                <p>{{ insufficientPaymentDetail?.order_delivery?.sender?.name || '-' }}</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">No. HP Pengirim</p>
                <p>{{ insufficientPaymentDetail?.order_delivery?.sender?.phone_number || '-' }}</p>
              </div>
            </div>
            <p class="text-sm font-medium mb-1 text-neutral-700">Alamat Pengirim</p>
            <p>{{ insufficientPaymentDetail?.order_delivery?.sender?.address || '-' }}</p>
            <div class="mt-6 p-2 bg-neutral-200 rounded-md">
              <p class="text-sm font-medium mb-1 text-neutral-700">Detail Pickup</p>
              <p>{{ insufficientPaymentDetail?.order_delivery?.sender?.detail_address || '-' }}</p>
            </div>
          </div>
          <div class="p-6 mdmax:shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Info Penerima</p>
            <div class="flex justify-start gap-6 mb-6">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Nama Penerima</p>
                <p>{{ insufficientPaymentDetail?.order_delivery?.receiver?.name || '-' }}</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">No. HP Penerima</p>
                <p>{{ insufficientPaymentDetail?.order_delivery?.receiver?.phone_number || '-' }}</p>
              </div>
            </div>
            <p class="text-sm font-medium mb-1 text-neutral-700">Alamat Penerima</p>
            <p>{{ insufficientPaymentDetail?.order_delivery?.receiver?.address || '-' }}</p>
            <div class="mt-6 p-2 bg-neutral-200 rounded-md">
              <p class="text-sm font-medium mb-1 text-neutral-700">Detail Pickup</p>
              <p>{{ insufficientPaymentDetail?.order_delivery?.receiver?.detail_address || '-' }}</p>
            </div>
          </div>
        </div>
        <div class="flex-1 shadow-border-l mdmax:shadow-none">
          <div class="p-6 shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Foto Barang</p>
            <template v-if="insufficientPaymentDetail?.order_delivery?.goods_picture_url">
              <img :src="insufficientPaymentDetail?.order_delivery?.goods_picture_url" />
            </template>
            <p v-else>- Foto tidak tersedia -</p>
          </div>
          <div class="p-6 shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Informasi Pembayaran</p>
            <div class="mb-6">
              <p class="text-sm font-medium mb-1 text-neutral-700">Status</p>
              <p>{{ insufficientPaymentDetail?.payment_info?.status || '-' }}</p>
            </div>
            <div class="flex justify-start gap-6 mb-6">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Tipe Pembayaran</p>
                <p>{{ insufficientPaymentDetail?.payment_info?.payment_method || '-' }}</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Bank</p>
                <p>{{ insufficientPaymentDetail?.payment_info?.payment_provider || '-' }}</p>
              </div>
            </div>
            <div class="flex justify-start gap-6 mb-6">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">No Rekening</p>
                <p>{{ insufficientPaymentDetail?.payment_info?.payment_account_display || '-' }}</p>
              </div>
            </div>
          </div>
          <div class="p-6">
            <p class="text-xl font-bold mb-6 text-neutral-700">Status Pengiriman</p>
            <div class="flex gap-5" v-for="(tracking, index) in insufficientPaymentDetail?.tracking_infos" :key="'tracking' + index">
              <div class="line relative">
                <span class="inline-block w-5 h-5 rounded-full  border-4  relative z-1" :class="index === 0 ? 'bg-primary-500 border-primary-100' : 'bg-neutral-500 border-neutral-300'"></span>
                <span class="absolute border-dashed border-neutral-300 h-full w-px border left-1/2 transform -translate-x-1/2 top-0 z-0"></span>
              </div>
              <div class="status mb-6">
                <p class="text-sm mb-1">{{ tracking.time_display }}</p>
                <p class="text-neutral-700 mb-1">{{ tracking.main_info }}</p>
                <p class="text-sm">{{ tracking.additional_info }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-xs p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700" v-if="insufficientPaymentDetail.is_require_hubcek">
        <Info width="24" height="24" color="neutral-700" />Jangan lupa periksa kembali barang yang telah diterima sebelum memindahkan status order, pastikan sesuai dengan ukuran yang telah ditetapkan.
      </div>
    </div>
    <Modal :modalVisible="visibleConfirmModal" @close="toggleConfirmModal()" width="600px" id="confirmation-modal">
      <template slot="modal-content">
        <div class="p-1">
          <div class="flex items-start justify-start gap-6 mb-6">
            <span class="flex-shrink-0"><Alert color="neutral-700"/></span>
            <div class="flex-col flex gap-2 items-start">
              <p class="text-2xl font-bold">Konfirmasi</p>
              <p class="text-sm text-neutral-500 text-left">
                Pastikan Anda telah yakin untuk melakukan proses konfirmasi / perubahan status ini.
              </p>
              <div class="w-full text-left mt-6">
                <TextField label="Kode Transaksi" placeholder="Masukkan kode transaksi" v-model="referenceId" />
              </div>
            </div>
          </div>
          <div class="flex justify-end gap-4">
            <Button buttonText="Batal" type="secondary" @action="toggleConfirmModal()" :size="isMobile ? 'full' : 'regular'" />
            <Button buttonText="Konfirmasi" :disabled="!referenceId" type="primary" @action="confirmation()" :size="isMobile ? 'full' : 'regular'" />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { currencyFormat } from '@/util'
export default {
  filters: {
    currencyFormat
  },
  components: {
    Info: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Info'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button'),
    TextField: () => import(/* webpackChunkName: "form" */ '@/components/Forms/TextField'),
    // Textarea: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Textarea'),
    // LinkButton: () => import(/* webpackChunkName: "form" */ '@/components/Forms/LinkButton'),
    // CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Alert: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Alert'),
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal')
  },
  data() {
    return {
      referenceId: null,
      otherReason: null,
      packageLength: 0,
      packageWidth: 0,
      packageHeight: 0,
      packagePrice: 0,
      selectedApprovalStatus: null,
      visibleConfirmModal: false,
      status: {
        PYMWAI: 'text-neutral-500 bg-neutral-300',
        PYMCNF: 'text-white bg-system-warning',
        DLVD: 'text-white bg-system-success',
        CNC: 'text-white bg-system-error',
        HUBPRCD: 'text-white bg-system-warning',
        HUBRJCT: 'text-white bg-system-error'
      },
      deliveryServiceTypeList: [
        {
          name: 'Pickup and Dropoff',
          value: 'A'
        },
        {
          name: 'Pickup Only',
          value: 'P'
        },
        {
          name: 'Dropoff Only',
          value: 'D'
        }
      ],
      rejectReasons: ['Terima', 'Barang Terlarang', 'Kurang Bayar', 'Lainnya'],
      selectedReason: null,
      visibleAddCostModal: false,
      visibleOtherModal: false,
      otherReasonError: null
    }
  },
  computed: {
    ...mapGetters('order', ['insufficientPaymentDetail']),
    ...mapGetters('common', ['isMobile']),
    orderId() {
      return this.$route.params.id
    },
    statusClass() {
      return this.status[this.insufficientPaymentDetail.status]
    },
    alreadyResponsed() {
      return ['HUBRJCT', 'HUBPRCD'].indexOf(this.insufficientPaymentDetail.status) > -1
    },
    invalidPackageInformation() {
      return (
        !this.packageLength ||
        this.packageLength === 0 ||
        !this.packageWidth ||
        this.packageWidth === 0 ||
        !this.packageHeight ||
        this.packageHeight === 0 ||
        !this.packagePrice ||
        this.packagePrice === 0
      )
    },
    isConfirmButtonVisible() {
      return this.insufficientPaymentDetail.status === 'OHUBPEND'
    }
  },
  created() {
    this.getInsufficientPaymentInfo()
  },
  methods: {
    ...mapActions('order', ['getInsufficientPaymentDetail', 'paymentConfirm']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    confirmation() {
      this.visibleConfirmModal = false
      this.showLoading()
      let self = this
      this.paymentConfirm({
        orderId: this.orderId,
        payloads: {
          reference_id: self.referenceId
        }
      }).then(() => {
        this.hideLoading()
        this.setToast({
          options: { type: 'success', duration: 1000, primaryText: 'Order Status telah berubah', secondaryText: 'Data telah terimpan dalam sistem.', callback: this.handleCallback }
        })
      })
    },
    toggleConfirmModal() {
      this.visibleConfirmModal = !this.visibleConfirmModal
    },
    handleCallback() {
      this.$router.push('/order/insufficient-payment')
    },
    reverseObject(array) {
      let newArr = Object.assign([], array)
      return newArr && newArr.reverse()
    },
    getServiceType(value) {
      return this.deliveryServiceTypeList.filter(item => item.value === value)[0]?.name
    },
    getInsufficientPaymentInfo() {
      this.showLoading()
      this.getInsufficientPaymentDetail({
        orderId: this.orderId
      }).then(() => {
        this.hideLoading()
      })
    }
  }
}
</script>
<style></style>
